export const colors = {
  white: "#F1F5F2",
  green: "#092b22",
  tan: "#e0c1a4",
  lightGreen: "#a6ae95",
  grey: "#E3E6DF",
};
